import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter9 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);


    return (
        <>

             {/* Chapter 9 */}
                <section id="section9" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter9Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph1}
                    </p>

                    <p className="drivers-handbook-paragraph">
                         {language.chapter9Paragraph2}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph3}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph4}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph5}
                    </p>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter9Subheading1}
                    </h3>
                    

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter9Subheading2}
                    </h3>
                    <ul className="drivers-handbook-list">
                        <li> {language.chapter9List21}
                        </li>
                        <li>
                             {language.chapter9List22}
                        </li>
                        <li>
                             {language.chapter9List23}
                        </li>
                        <li>
                             {language.chapter9List24}
                        </li>
                        <li> {language.chapter9List25}
                        </li>
                    </ul>

                    <h3 className="drivers-handbook-subheading"> {language.chapter9Subheading3}</h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph6}
                    </p>
                    <ul className="drivers-handbook-list">
                       {language.chapter9List3}
                    </ul>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph7}
                    </p>

                    <p className="drivers-handbook-paragraph">
                         {language.chapter9Paragraph8}
                    </p>

                    <h3 className="drivers-handbook-subheading">{language.chapter9Subheading4}</h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph9}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph10}
                    </p>


                    <h3 className="drivers-handbook-subheading">
                        {language.chapter9Subheading5}
                    </h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph11}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph12}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph13}

                    </p>

                    <h3 className="drivers-handbook-subheading">{language.chapter9Subheading6}</h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter9Paragraph14}
                    </p>
                </section>
        </>
    )

}

export default Chapter9;
